import { render, staticRenderFns } from "./shopTypeManage.vue?vue&type=template&id=33c7cff0&scoped=true"
import script from "./shopTypeManage.vue?vue&type=script&lang=js"
export * from "./shopTypeManage.vue?vue&type=script&lang=js"
import style0 from "./shopTypeManage.vue?vue&type=style&index=0&id=33c7cff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c7cff0",
  null
  
)

export default component.exports